import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import i18n from "@/i18n";

export function cn(...inputs: Array<ClassValue>) {
	return twMerge(clsx(inputs));
}

export const getFlagEmoji = (countryCode: string | null | undefined) => {
	if (!countryCode) return "🌍";
	return countryCode
		.toUpperCase()
		.replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397));
};

export function toLocalISOString(dateInput?: string | Date | null): string {
	if (!dateInput) return "";
	const date = new Date(dateInput);

	if (Number.isNaN(date.getTime())) return "";

	const offsetMs = date.getTimezoneOffset() * 60 * 1000;
	const localDate = new Date(date.getTime() - offsetMs);

	return localDate.toISOString().slice(0, 16);
}

export function formatScore(score: number): string {
	const formatted = parseFloat(score.toFixed(2)).toString();
	if (score > 0) return `+${formatted}`;
	return formatted;
}

export function formatDisplayDateOnly(dateInput?: string | Date | null): string {
	if (!dateInput) return i18n.t("common:date.choose");
	const date = new Date(dateInput);
	if (Number.isNaN(date.getTime())) return i18n.t("common:date.invalid");

	return date.toLocaleDateString(i18n.language, {
		day: "numeric",
		month: "long",
		year: "numeric",
	});
}

export function scoreColor(score: number, fallback = "text-slate-400"): string {
	if (score > 0) return "text-emerald-600";
	if (score < 0) return "text-red-500";
	return fallback;
}

export function formatDisplayDate(dateInput?: string | Date | null): string {
	if (!dateInput) return i18n.t("common:date.choose");
	const date = new Date(dateInput);
	if (Number.isNaN(date.getTime())) return i18n.t("common:date.invalid");

	return date.toLocaleString(i18n.language, {
		day: "numeric",
		month: "long",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	});
}
